import { useState } from 'react';
import { Container, Card, Typography, CardContent, Fab } from '@material-ui/core';
import Header from '../../../../components/Header';
import { FETCH_COMMON_FILES } from '../../../../graphql/queries';
import { useQuery } from '@apollo/client';
import List from './List';
import CreateDialog from './CreateDialog';
import AddIcon from '@material-ui/icons/Add';
import { useSnackbar } from "notistack";

export default function UniversitySimPage({ history }) {

    const { enqueueSnackbar } = useSnackbar();
    const [showCreate, setShowCreate] = useState(false);
    const [dataEdit, setDataEdit] = useState();

    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
  
    const { loading, error, data, networkStatus, refetch } = useQuery(FETCH_COMMON_FILES, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      variables: {
        limit: rowsPerPage,
        page: currentPage + 1
      }
    });

    return(
        <>
            <Header onBack={() => {
                history.goBack()
            }}/>

            <Container maxWidth="sm" style={{ marginTop: 86 }}>
                <Card>
                    <CardContent>
                        <Typography variant="h5" component="h1">Universidade SIM</Typography>
                    </CardContent>

                    <List 
                        onDelete={() => {
                            enqueueSnackbar('Conteúdo excluído com sucesso!');
                            refetch();
                        }}
                        onEdit={(item) => setDataEdit(item)}
                        {...{ loading, error, data, networkStatus, currentPage, setCurrentPage, rowsPerPage, setRowsPerPage }} 
                    />
                    
                </Card>
            </Container>

            <CreateDialog 
                open={showCreate} 
                handleClose={() => setShowCreate(false) } 
                onCreate={() => {
                    enqueueSnackbar('Conteúdo cadastrado com sucesso!');
                    refetch();
                    setShowCreate(false);
                }}
            />

            <Fab color="primary" onClick={() => setShowCreate(true) } style={{ position: 'absolute', bottom: 48, right: 48 }}>
                <AddIcon />
            </Fab>
        </>
    )

}